module.exports = "/images/guest-background.jpg?98fd392aa392399a1a4ff225dd6c947c";